export class NewStatechart {
  modelId: string;
}

export const newStatechart: NewStatechart = { modelId: null };
